<template>
  <div
    v-if="!to"
    class="Row"
    :class="{
      'Row-header' : header,
      'Row-body'   : !header
    }"
  >
    <slot></slot>
  </div>

  <router-link
    v-else
    :to="to"
    class="Row clickable" :class="{
      'Row-header' : header,
      'Row-body'   : !header
    }"
  >
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    props: {
      header: {
        type: Boolean,
        default: false
      },

      to: {
        type: [ String, Object ]
      }
    },

    methods: {
      sort () {
        console.log (this.$parent);
        console.log (this.$el.textContent);
      }
    }
  };
</script>

<style lang="scss">
  .Row {
    display: table-row;

    &-header {
      .Cell {
        color: rgba(var(--yellow), 1);
        padding: 1rem;
        text-align: center;
        font-weight: bold;
      }
    }

    &-body {
      border-top: $w3s-border-region;

      .Cell {
        color: $w3s-tan-dark;
        padding: 8px;
        position: relative;
        text-align: center;

        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:empty {
          &:before {
            color: $w3s-grey;
            font-size: 12px;
            content: 'N/A';
          }
        }
      }

      &:last-child {
        border-bottom: $w3s-border-region;
      }

      &:nth-child(odd) {
        background-color: shade($w3s-white, 3);
      }

      &.green {
        background-color: rgba(var(--green), .03);

        &:nth-child(odd) {
          background-color: rgba(var(--green), .06);
        }
      }

      &.red {
        background-color: rgba(var(--red), .03);

        &:nth-child(odd) {
          background-color: rgba(var(--red), .06);
        }
      }
    }

    &-error {
      display: inline-block;
      width: 100%;
      text-align: center;
      padding: 10px 0;
    }
  }
</style>